module.exports = __webpack_public_path__ + "static/img/11_4Archive_18b_Kaprow_scriptPP_4.6b7ece4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kaprow/archive/11_4Archive_18b_Kaprow_scriptPP_4.jpg
// module id = nCyu
// module chunks = 0